import { Card, CardContent, Fab, Icon } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { MODULE_EXTRANET_QUOTES } from '../../redux/authorizedApps/authorizedAppsConstants';
import { downloadReactTableAsXlsx } from '../../utils';
import CustomizedTextField from '../Input/CustomizedTextField';

class QuotesCounters extends Component {

    download() {
        if (this.props.quotes.filteredAndSortedQuotes.length <= 0)
            return;

        downloadReactTableAsXlsx(this.props.quotes.filteredAndSortedQuotes, this.props.columns, "Devis")
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin counters-card without-side-padding-only-small-screen">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                    <div className="col-lg-3 col-md-4 col-sm-3 col-3 control-margin-top">
                        {this.props.quotes.filteredAndSortedQuotes.length > 0 ? (
                            <Fab variant="extended" type="submit" className="div-center" color="secondary" onClick={this.download.bind(this)}>
                                <Icon>download</Icon>
                            </Fab>
                        ) : null}
                    </div>
                    <div className="offset-lg-6 col-lg-3 offset-md-4 col-md-4 col-sm-9 col-9">
                        <CustomizedTextField
                            id="nb-total-quotes"
                            label="Nb devis"
                            className="full_size light-disabled"
                            value={this.props.tableState.nbTotalResults[MODULE_EXTRANET_QUOTES]}
                            margin="normal"
                        />
                    </div>
                </CardContent>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        quotes: state.quotes,
        tableState: state.tableState,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotesCounters);
